import React, { useState, useEffect, useContext } from 'react';
import './CartItems.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/cart_cross_icon.png';
const imgUrl = process.env.REACT_APP_ASSET_PATH;

const CartItems = () => {

  const { getTotalCartAmount, getTotalCartItems, all_product, cartItems, removeFromCart, getPromoDiscount } = useContext(ShopContext);
  const navigate = useNavigate();
  const apiURL = process.env.REACT_APP_API_URL;
  const [promo, setPromo] = useState("");
  const [promoError, setPromoError] = useState(""); 
  const [promoSuccess, setPromoSuccess] = useState(""); // New state to store success message
  
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const [user, setUser] = useState(localStorage.getItem("user")); 

  useEffect(() => {
    const handleStorageChange = () => {
      setUser(localStorage.getItem("user")); 
    };
    if(localStorage.getItem("promo") !== null) {
      setPromo(JSON.parse(localStorage.getItem("promo")).code);
      setPromoSuccess("Promo Code applied successfully!")
    }
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange); 
    };
  }, []); 

  const handleCheckout = () => {
    let getUrl = apiURL + `api/promo/check?code=${encodeURIComponent(promo)}`;
    axios.get(getUrl, {
      headers: {
        Accept: 'application/json',
        "ngrok-skip-browser-warning": "10419"
      }
    }).then((res) => {
      if (res.data.percent != null && res.data.valid === false) {
        setPromoSuccess("");
        localStorage.removeItem("promo");
        setPromoError("Promo Code expired. Please try again!");
        // window.location.reload(true);
        
      } else {
        const currentUser = localStorage.getItem("user"); 
        setUser(currentUser); 
        navigate('/order', { state: { totalCartAmount: getTotalCartAmount() } }); 
        setTimeout(() => {
          window.scrollTo(0, 0); 
        }, 200); 
      }
    })
    .catch((err) => {
      console.log(err);
      alert("Error occured in promo validation, please try adding promo again !!");
    });

  };

  const handlePromo = () => {
    setPromoError(""); 
    setPromoSuccess(""); // Reset success message when applying a new coupon
    localStorage.removeItem("promo");
    // const storedPromo = localStorage.getItem("promo");
    // if (storedPromo !== null) {
    //   setPromoSuccess("Promo Code already applied!"); // Show success message if coupon is already applied
    //   return;
    // }
    
    let getUrl = apiURL + `api/promo/check?code=${encodeURIComponent(promo)}`;
    axios.get(getUrl, {
      headers: {
        Accept: 'application/json',
        "ngrok-skip-browser-warning": "10412"
      }
    })
    .then((res) => {
      if (res.data.percent != null && res.data.valid === true) {
        localStorage.setItem("promo", JSON.stringify(res.data));
        setPromoSuccess("Promo Code applied successfully!"); // Show success message when coupon is applied
        if (getPromoDiscount() > 0) {
          setShowPromoPopup(true);
        }
      } else {
        setPromoError("Promo Code does not exist. Please try again!"); // Show error if coupon is invalid
      }
    })
    .catch((err) => {
      console.log(err);
      setPromoError("An error occurred. Please try again.");
    });
  };

  return (
    <div className="cartitems">
      <div className="summary">Order Summary</div>
      <div className="cartitems-format-main">
        <p>Products</p>
        <p>Title</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />
      {
        all_product.map((e) => {
          if (cartItems[e.id] > 0) {
            return (
              <div key={e.id}>
                <div className="cartitems-format cartitems-format-main">
                  <img src={imgUrl + e.img} alt='' className='carticon-product-icon' />
                  <div>{e.name}</div>
                  <div>${e.price}</div>
                  <button className='cartitems-quantity'>{cartItems[e.id]}</button>
                  <div>${(e.price * cartItems[e.id]).toFixed(2)} </div>
                  <img className="cartitems-remove-icon" src={remove_icon} onClick={() => removeFromCart(e.id)} alt="" />
                </div>
                <hr />
              </div>
            );
          }
          return null;
        })
      }
    
      <div className="cartitems-down">
        <div className="cartitems-total">
          <div>
            <div className="cartitems-total-item">
              <p>Cart Total (incl. GST)</p>
              <p> $
                  {getPromoDiscount() > 0 
                  ? (parseFloat(getTotalCartAmount().toFixed(2)) - parseFloat(getPromoDiscount().toFixed(2))).toFixed(2) 
                  : getTotalCartAmount().toFixed(2)}</p>
            </div>
          </div>
          <button
            onClick={handleCheckout}
            disabled={getTotalCartAmount() === 0}
            style={{
              backgroundColor: getTotalCartAmount() === 0 ? '#ccc' : '',
              cursor: getTotalCartAmount() === 0 ? 'not-allowed' : 'pointer'
            }}
          >
            PROCEED TO CHECKOUT
          </button>
        </div>
      </div>

      {/* Login Popup */}
      {showPromoPopup && (
        <div className="login-popup">
          <div className="login-popup-content">
            <h3>Congratulations !!!!</h3>
            <p>You have saved ${getPromoDiscount().toFixed(2)} today!</p>
            <button onClick={() => setShowPromoPopup(false)}>Ok</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartItems;
